import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { Address } from '@lukso/controllerapps-sharedlogic-primitives'

const InitialControllerAddressPropsSchema = z.object({
  initialControllerAddressValue: z.instanceof(Address),
})

type InitialControllerAddressProps = z.infer<
  typeof InitialControllerAddressPropsSchema
>

export class InitialControllerAddress extends ValueObject<InitialControllerAddressProps> {
  public getValue(): Address {
    return this.props.initialControllerAddressValue
  }

  /**
   * @returns A 0x-prefixed checksum-based hex string of the address.
   */
  public getChecksumValue(): string {
    return this.props.initialControllerAddressValue.getChecksumValue()
  }

  public static create(
    props: InitialControllerAddressProps
  ): InitialControllerAddress {
    const validatedProps = InitialControllerAddressPropsSchema.parse(props)
    return new InitialControllerAddress(validatedProps)
  }
}
